import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { API, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Nouveau mot de passe" subtitle="Choisissez un nouveau mot de passe sécurisé">
      {!token ? (
        <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="reset-no-token">
          Lien invalide. <Link to="/forgot-password" className="font-medium underline">Demander un nouveau lien</Link>
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="reset-error">{error}</p>}
          <div>
            <Label htmlFor="password">Nouveau mot de passe (8 caractères min.)</Label>
            <Input id="password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" className="mt-1" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit-button">
            {loading ? "Enregistrement..." : "Réinitialiser"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
